export default __webpack_public_path__ + "static/media/phone-bezel.787be7c6.svg";